import { useMutation, useQuery } from "@tanstack/react-query";
import { IActionResponse, IActionResult } from "../../../services/proxies";
import {  CommunityDevelopmentDto, CommunityDevelopmentFavoriteDto, CommunityDevelopmentNoteDto, CommunityDevelopmentReplyDto, SearchCommunityDevelopmentDto, SearchDto } from "../../../services/dto";
import { CommunityDevelopmentClient } from "../../../services/proxies/popHub/communityDevelopmentClient";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace CommunityDevelopmentService {
    const communityDevelopmentClient = new CommunityDevelopmentClient();

    export const getLookups = () =>
        useQuery({
            queryKey: ["communityDevelopmentlookupsQuery"],
            queryFn: async (): Promise<any> =>
                await communityDevelopmentClient.getLookupsAsync(),
            select: (data) => {
                return {
                    responses: data?.responses,
                    tags: data?.tags,
                    category: data?.category
                };
            },
        });

    export const getCommunityDevelopmentQuery = (CommunityId: string | undefined) =>
        useQuery({
            queryKey: ["communityDevelopmentQuery", CommunityId],
            queryFn: async () => await communityDevelopmentClient.getCommunityDevelopmentAsync(CommunityId),
            enabled: Boolean(CommunityId) && CommunityId !== Constants.emptyGuid,
        });

    export const gridQuery = (searchQuery: SearchCommunityDevelopmentDto) =>
        useQuery({
            queryKey: ["communityDevelopmentGridQuery", searchQuery],
            queryFn: async () =>
                await communityDevelopmentClient.searchCommunityDevelopmentAsync(searchQuery),
        });

    export const saveCommunityDevelopment = () =>
        useMutation<IActionResult<CommunityDevelopmentDto>, Error, CommunityDevelopmentDto>({
            mutationFn: async (payload: CommunityDevelopmentDto) => {
                return await communityDevelopmentClient.saveCommunityDevelopmentAsync(payload);
            },
        });

    export const saveCommunityDevelopmentFavorite = () =>
        useMutation<IActionResult<CommunityDevelopmentFavoriteDto>, Error, CommunityDevelopmentFavoriteDto>({
            mutationFn: async (payload: CommunityDevelopmentFavoriteDto) => {
                return await communityDevelopmentClient.saveCommunityDevelopmentFavoriteAsync(payload);
            },
        });

    export const deleteCommunityDevelopment = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (communityId: string | undefined) => {
                return await communityDevelopmentClient.deleteCommunityDevelopmentAsync(communityId);
            },
        });

    export const getCommunityDevelopmentNotesQuery = (searchQuery: SearchDto | undefined) =>
        useQuery({
            queryKey: ["CommunityDevelopmentNotesQuery", searchQuery],
            queryFn: async () => await communityDevelopmentClient.getCommunityDevelopmentNotesAsync(searchQuery),
        });

    export const getCommunityDevelopmentNoteQuery = (notesId: string | undefined) =>
        useQuery({
            queryKey: ["CommunityDevelopmentNoteQuery", notesId],
            queryFn: async () => await communityDevelopmentClient.getCommunityDevelopmentNoteAsync(notesId),
            enabled: Boolean(notesId) && notesId != Constants.emptyGuid,
        });

    export const saveCommunityDevelopmentNote = () =>
        useMutation<IActionResult<CommunityDevelopmentNoteDto>, Error, CommunityDevelopmentNoteDto>({
            mutationFn: async (payload: CommunityDevelopmentNoteDto) => {
                return await communityDevelopmentClient.saveCommunityDevelopmentNoteAsync(payload);
            },
        });

    export const deleteCommunityDevelopmentNote = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (id: string | undefined) => {
                return await communityDevelopmentClient.deleteCommunityDevelopmentNoteAsync(id);
            },
        });

    export const getCommunityDevelopmentRepliesQuery = (CommunityId: string | undefined) =>
        useQuery({
            queryKey: ["communityDevelopmentRepliesQuery", CommunityId],
            queryFn: async () => await communityDevelopmentClient.getCommunityDevelopmentRepliesAsync(CommunityId),
            enabled: Boolean(CommunityId),
        });
    
    export const saveCommunityDevelopmentReply = () =>
        useMutation<IActionResult<CommunityDevelopmentReplyDto>, Error, CommunityDevelopmentReplyDto>({
            mutationFn: async (payload: CommunityDevelopmentReplyDto) => {
                return await communityDevelopmentClient.saveCommunityDevelopmentReplyAsync(payload);
            },
        });
}